import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import { cx } from '../../../core/utils'

import s from './index.css'

const renderName = (filterItem) => {
  const { options } = filterItem
  let name = filterItem.name
  const filterOptions = options.filter((item) => {
    if (item.chosen) return true
    return false
  })
  if (filterOptions.length) {
    name = `${filterOptions[0].name}${filterOptions.length === 1 ? '' : `等${filterOptions.length}个`}`
  }
  return name
}
class FilterCourse extends React.Component {
  static propTypes = {
    filters: PropTypes.array.isRequired,
    filterCourseHandle: PropTypes.func.isRequired,
  }

  static defaultProps = {
    filters: [],
  }

  filterCourse(filterItem, name) {
    const { filters, filterCourseHandle } = this.props
    const queryMap = filters.reduce((filterMap, item) => {
      const chosenMap = { ...filterMap }
      const choseItems = item.options.filter((op) => {
        // chosen这个字段是后端返回的，在进行筛选的时候需要判断 之前选中的不能被再次选中
        if (op.chosen && (item.queryKey !== filterItem.queryKey || op.name !== name)) return true
        if (!op.chosen && item.queryKey === filterItem.queryKey && op.name === name) return true
        return false
      })
      if (choseItems.length) {
        chosenMap[item.queryKey] = `${choseItems.map(p => p.name).join(',')}`
      }
      return chosenMap
    }, {})
    filterCourseHandle(queryMap)
  }

  renderFilterItem(filterItem) {
    const { options } = filterItem
    return (
      <div className={s.filterItem} key={filterItem.queryKey}>
        <div className={s.title}>
          <span>{renderName(filterItem)}</span>
          <span className={s.filterIcon} />
        </div>
        <div className={s.filterCard}>
          {options && options.map(item => (
            <div
              className={cx({
                [`${s.filterCardItem}`]: true,
                [`${s.chosen}`]: item.chosen,
              })}
              key={`filter-option-${item.name}`}
              onClick={() => this.filterCourse(filterItem, item.name)}
            >
              <p>{item.name}</p>
              {item.chosen && <span className={s.choseIcon} />}
            </div>
          ))}
        </div>
      </div>
    )
  }

  render() {
    const { filters } = this.props

    return (
      <div className={s.container}>
        {filters && filters.map((item, idx) => this.renderFilterItem(item, idx))}
      </div>
    )
  }
}

export default withStyles(s)(FilterCourse)



// WEBPACK FOOTER //
// ./src/components/p_serial/filterCourse/index.js